import * as Common from '@/agiles/common';

export class SystemLog extends Common.ObjectBase {
  constructor() {
    super('SystemLog');
  }
  public id: number;
  public startTime: Date;
  public finishTime: Date; 
  public elapsedTime: number; 
  public status: logStates;
  public statusDescription: string;
  public title: string;
  public description: string;
}

export enum logStates {
  running,
  failed,
  succeeded,
  succeededWithErrors
}

export class SystemLogQuery extends Common.LoadQuery {
  constructor() {
    super('SystemLogQuery', SystemLog);
    this.sort ="startTime";
    this.isDescending = true;
  }
  public startedFrom: Date = null;
  public startedTo:  Date = null;
  public id :number = null;
  
}
